export const SocialActions = Object.freeze({
  LOAD_FB_SDK_AND_UPDATE_LOGIN_STATUS: 'LOAD_FB_SDK_AND_UPDATE_LOGIN_STATUS',
  LOAD_FB_SDK_AND_UPDATE_TOKEN_VALIDITY: 'LOAD_FB_SDK_AND_UPDATE_TOKEN_VALIDITY',
  SET_FACEBOOK_TOKEN_VALIDITY: 'SET_FACEBOOK_TOKEN_VALIDITY',
  UPDATE_FACEBOOK_TOKEN_VALIDITY: 'UPDATE_FACEBOOK_TOKEN_VALIDITY',
  CHECK_FACEBOOK_CONNECT_STATUS: 'CHECK_FACEBOOK_CONNECT_STATUS',
  REMOVE_FACEBOOK_DATA: 'REMOVE_FACEBOOK_DATA',
  ALLOWLIST_ALL: '*',
});
